module.exports = __webpack_public_path__ + "static/media/visa.8599e1ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/visa.svg
// module id = 1151
// module chunks = 2